import React from "react";
import styles from "../HeroBar/HeroBar.module.css";
import { PortableText } from "@portabletext/react";
const ptComponents = {
  marks: {
    purple: ({ children }) => (
      <span style={{ color: "#6524EB" }}>{children}</span>
    ),
    strong: ({ children }) => <strong>{children}</strong>,
    break: ({ children }) => (
      <>
        {children}
        <br />
      </>
    ),
  },
  list: {
    bullet: ({ children }) => <ul className="list-disc ml-6">{children}</ul>,
    number: ({ children }) => <ol className="list-decimal ml-6">{children}</ol>,
  },
};

const HeroBar2 = ({
  title,
  subtitle,
  titleMarginInline,
  titleWidth,
  titleTextAlign,
  subtitleMarginInline,
  subtitleWidth,
  subtitleTextAlign,
  subtitleJustifyContent,
  showEllipse = true,
}) => {
  const titleStyle = {
    ...(titleMarginInline && { marginInline: titleMarginInline }),
    ...(titleWidth && { width: titleWidth }),
    ...(titleTextAlign && { textAlign: titleTextAlign }),
  };
  const subtitleStyle = {
    ...(subtitleMarginInline && { marginInline: subtitleMarginInline }),
    ...(subtitleWidth && { width: subtitleWidth }),
    ...(subtitleTextAlign && { textAlign: subtitleTextAlign }),
    ...(subtitleJustifyContent && { justifyContent: subtitleJustifyContent }),
  };

  return (
    <div className={styles.HeroMain}>
      <div className={styles.heroBar}>
        <h1 className={styles.title} style={titleStyle}>
          <PortableText value={title} components={ptComponents} />
        </h1>
        <p className={styles.subtitle} style={subtitleStyle}>
          {subtitle}
        </p>
      </div>
      {showEllipse && (
        <div className={styles.Ellipse}
        
        >
          <img src="/Svg/Ellipse-green.svg" alt="Ellipse-green" />
        </div>
      )}
    </div>
  );
};

export default HeroBar2;
